import recipesJson from './recipes.json'
import type { Recipe, RecipesData } from '@/types'

export const recipesData: RecipesData = recipesJson as RecipesData

export const allRecipes = recipesData.recipes

export function isDesynthesisRecipe(recipe: Recipe): boolean {
  return recipe.id.includes('-分解-')
}
